import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';

import GiftItem from './GiftItem';
import useProductGiftRecommended from './hooks/useProductGiftRecommended';

function ProductGiftRecommend() {
    const data = useProductGiftRecommended();
    return (
        <Container fullWidth align='center'>
            <Contents spacing={18} align='flex-start'
                fullWidth >
                {data?.items.map((item) => (
                    <GiftItem item={item} key={item.itemId}/>
                ))}
            </Contents>
            {data?.title && (
                <Text size='xl' fontWeight='bold' color={colors.gray7}>
                    {data?.title}
                </Text>
            )}
        </Container>
    );
}

const Container = styled(Column)`
    margin-top: 32px;
`;

const Contents = styled(Row)`
    padding: 0 20px;
    scroll-padding: 0 20px;
    overflow-x: auto;
    white-space: nowrap;
    margin-bottom: 16px;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export default ProductGiftRecommend;
